export default __webpack_public_path__ + "static/media/holdingTea.efc69b1a.jpg";